<footer class="footer text-center text-sm-start">
  <span class="text-muted d-none d-sm-inline-block float-end">Crafted with <i class="mdi mdi-heart text-danger"></i> &copy;hatam </span>
</footer>